<template>
    <div class="ur-card">
        <!--
            $ver: v0.1.0
            카드 내부 영역입니다. 예제에서 사용된 class를 활용하여 카드 내부를 표현할 수 있습니다.
            #Area inside the card. The class used in the example can be used to express the inside of the card.
        -->
        <slot></slot>
    </div>
</template>

<script>
// ur-card는 일정 규격의 형태를 띄고 있으며, 내부적으로 사용자가 정의한 컨텐츠를 랜더링합니다.
// #The ur-card takes the form of standard and internally renders user-defined content.

export default {
        name: 'urCard',
        props: {
        },
        data() {return {}},
        computed: {
        }
    };


</script>
